<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="menu-gradient dark print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall"
>
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="w-full items-center p-4">
            <!-- Logo -->
            <div class="flex items-center justify-center">
                <img
                    class="w-30"
                    src="images/logo/logo-gtb-user-management-2.svg" />
            </div>
        </div>
        <!-- User -->
        <div class="flex w-full flex-col items-center p-4">
            <div class="classy-profile-avatar relative h-24 w-24">
                @if (user.avatar) {
                    <img
                        class="classy-profile-avatar__image h-full w-full rounded-full object-cover"
                        style="object-position: 50% 20%"
                        [src]="user.avatar"
                        alt="User avatar"
                    />
                }
                @if (!user.avatar) {
                    <img
                        class="classy-profile-avatar__image h-full w-full rounded-full"
                        src="images/avatars/default-avatar.png"
                        alt="User avatar"
                    />
                }
                <span
                    class="classy-profile-avatar__status"
                    aria-hidden="true"
                ></span>
            </div>
            <div class="mt-6 flex w-full flex-col items-center justify-center">
                <div
                    class="w-full overflow-hidden text-ellipsis whitespace-nowrap text-center font-medium leading-normal"
                >
                    {{ user.employeeCode }}
                </div>
                <div
                    class="w-full overflow-hidden text-ellipsis whitespace-nowrap text-center font-medium leading-normal"
                >
                    {{ user.name }}
                </div>
                <div
                    class="mt-0.5 w-full overflow-hidden text-ellipsis whitespace-nowrap text-center text-md font-medium leading-normal text-energy-orange"
                >
                    {{ user.position }}
                </div>
            </div>
        </div>
    </ng-container>
    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationFooter>
        <div class="nav-footer">
            <!-- Brand -->
            <div class="nav-footer-brand">
                <a class="cursor-pointer" [routerLink]="'/'">
                    <img
                        class="w-36"
                        src="images/logo/logo-text-on-dark.webp" />
                </a>
            </div>
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <div
        class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden"
    >
        <!-- Navigation toggle button -->
        <button
            mat-icon-button
            (click)="toggleNavigation('mainNavigation')"
            class="relative z-10 rounded-xl hover:bg-white/50 dark:hover:bg-white/10 transition"
        >
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>

        <!-- Components -->
        <div class="relative z-10 ml-auto flex items-center pl-2">
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <scheme></scheme>
            <user></user>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-auto flex-col">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer -->
    <!--<div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>
    </div>-->
</div>
